import { FieldBase } from "./field-base.model";

export class TextareaField extends FieldBase<string> {
  controlType = "textarea";
}
